import { Empty } from "antd";
import React from "react";

export default function ErrorLoading({ background, language }) {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Empty
        description={
          language === "en"
            ? "Something went wrong. Please try again."
            : "Algo salió mal. Vuelva a intentar."
        }
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          fontSize: "20px",
          fontFamily: "Open Sans",
          color: background === "dark" ? "white" : "black",
        }}
      />
    </div>
  );
}
